/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Nochangelogfound2Inputs */

const id_sandboxes_nochangelogfound2 = /** @type {(inputs: Sandboxes_Nochangelogfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada changelog ditemukan`)
};

const ms_sandboxes_nochangelogfound2 = /** @type {(inputs: Sandboxes_Nochangelogfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada changelog ditemui`)
};

const da_sandboxes_nochangelogfound2 = /** @type {(inputs: Sandboxes_Nochangelogfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen ændringslog fundet`)
};

const de_sandboxes_nochangelogfound2 = /** @type {(inputs: Sandboxes_Nochangelogfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Änderungsprotokoll gefunden`)
};

const en_us2_sandboxes_nochangelogfound2 = /** @type {(inputs: Sandboxes_Nochangelogfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No changelog found`)
};

const es_es2_sandboxes_nochangelogfound2 = /** @type {(inputs: Sandboxes_Nochangelogfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontró registro de cambios`)
};

const es_mx2_sandboxes_nochangelogfound2 = /** @type {(inputs: Sandboxes_Nochangelogfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontró registro de cambios`)
};

const fil_sandboxes_nochangelogfound2 = /** @type {(inputs: Sandboxes_Nochangelogfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang nakitang talaan ng pagbabago`)
};

const fr_sandboxes_nochangelogfound2 = /** @type {(inputs: Sandboxes_Nochangelogfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun journal des modifications trouvé`)
};

const it_sandboxes_nochangelogfound2 = /** @type {(inputs: Sandboxes_Nochangelogfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun registro modifiche trovato`)
};

const hu_sandboxes_nochangelogfound2 = /** @type {(inputs: Sandboxes_Nochangelogfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nem található változásnapló`)
};

const nl_sandboxes_nochangelogfound2 = /** @type {(inputs: Sandboxes_Nochangelogfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen wijzigingslogboek gevonden`)
};

const no_sandboxes_nochangelogfound2 = /** @type {(inputs: Sandboxes_Nochangelogfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen endringslogg funnet`)
};

const pl_sandboxes_nochangelogfound2 = /** @type {(inputs: Sandboxes_Nochangelogfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie znaleziono dziennika zmian`)
};

const pt_br2_sandboxes_nochangelogfound2 = /** @type {(inputs: Sandboxes_Nochangelogfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum registro de alterações encontrado`)
};

const pt_sandboxes_nochangelogfound2 = /** @type {(inputs: Sandboxes_Nochangelogfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum registo de alterações encontrado`)
};

const ro_sandboxes_nochangelogfound2 = /** @type {(inputs: Sandboxes_Nochangelogfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nu s-a găsit niciun jurnal de modificări`)
};

const fi_sandboxes_nochangelogfound2 = /** @type {(inputs: Sandboxes_Nochangelogfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muutoslokia ei löytynyt`)
};

const sv_sandboxes_nochangelogfound2 = /** @type {(inputs: Sandboxes_Nochangelogfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen ändringslogg hittades`)
};

const vi_sandboxes_nochangelogfound2 = /** @type {(inputs: Sandboxes_Nochangelogfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy nhật ký thay đổi`)
};

const tr_sandboxes_nochangelogfound2 = /** @type {(inputs: Sandboxes_Nochangelogfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Değişiklik günlüğü bulunamadı`)
};

const cs_sandboxes_nochangelogfound2 = /** @type {(inputs: Sandboxes_Nochangelogfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenalezen žádný seznam změn`)
};

const bg_sandboxes_nochangelogfound2 = /** @type {(inputs: Sandboxes_Nochangelogfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Няма намерен дневник на промените`)
};

const ru_sandboxes_nochangelogfound2 = /** @type {(inputs: Sandboxes_Nochangelogfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Журнал изменений не найден`)
};

const uk_sandboxes_nochangelogfound2 = /** @type {(inputs: Sandboxes_Nochangelogfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Журнал змін не знайдено`)
};

const ar_sandboxes_nochangelogfound2 = /** @type {(inputs: Sandboxes_Nochangelogfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يتم العثور على سجل تغييرات`)
};

const hi_sandboxes_nochangelogfound2 = /** @type {(inputs: Sandboxes_Nochangelogfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई बदलाव लॉग नहीं मिला`)
};

const th_sandboxes_nochangelogfound2 = /** @type {(inputs: Sandboxes_Nochangelogfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พบบันทึกการเปลี่ยนแปลง`)
};

const ja_sandboxes_nochangelogfound2 = /** @type {(inputs: Sandboxes_Nochangelogfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新履歴が見つかりません`)
};

const zh_cn2_sandboxes_nochangelogfound2 = /** @type {(inputs: Sandboxes_Nochangelogfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到更新日志`)
};

const zh_hant1_sandboxes_nochangelogfound2 = /** @type {(inputs: Sandboxes_Nochangelogfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到更新日誌`)
};

const ko_sandboxes_nochangelogfound2 = /** @type {(inputs: Sandboxes_Nochangelogfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`변경 내역을 찾을 수 없음`)
};

/**
* | output |
* | --- |
* | "No changelog found" |
*
* @param {Sandboxes_Nochangelogfound2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_nochangelogfound2 = /** @type {((inputs?: Sandboxes_Nochangelogfound2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Nochangelogfound2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_nochangelogfound2(inputs)
	if (locale === "ms") return ms_sandboxes_nochangelogfound2(inputs)
	if (locale === "da") return da_sandboxes_nochangelogfound2(inputs)
	if (locale === "de") return de_sandboxes_nochangelogfound2(inputs)
	if (locale === "en-US") return en_us2_sandboxes_nochangelogfound2(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_nochangelogfound2(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_nochangelogfound2(inputs)
	if (locale === "fil") return fil_sandboxes_nochangelogfound2(inputs)
	if (locale === "fr") return fr_sandboxes_nochangelogfound2(inputs)
	if (locale === "it") return it_sandboxes_nochangelogfound2(inputs)
	if (locale === "hu") return hu_sandboxes_nochangelogfound2(inputs)
	if (locale === "nl") return nl_sandboxes_nochangelogfound2(inputs)
	if (locale === "no") return no_sandboxes_nochangelogfound2(inputs)
	if (locale === "pl") return pl_sandboxes_nochangelogfound2(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_nochangelogfound2(inputs)
	if (locale === "pt") return pt_sandboxes_nochangelogfound2(inputs)
	if (locale === "ro") return ro_sandboxes_nochangelogfound2(inputs)
	if (locale === "fi") return fi_sandboxes_nochangelogfound2(inputs)
	if (locale === "sv") return sv_sandboxes_nochangelogfound2(inputs)
	if (locale === "vi") return vi_sandboxes_nochangelogfound2(inputs)
	if (locale === "tr") return tr_sandboxes_nochangelogfound2(inputs)
	if (locale === "cs") return cs_sandboxes_nochangelogfound2(inputs)
	if (locale === "bg") return bg_sandboxes_nochangelogfound2(inputs)
	if (locale === "ru") return ru_sandboxes_nochangelogfound2(inputs)
	if (locale === "uk") return uk_sandboxes_nochangelogfound2(inputs)
	if (locale === "ar") return ar_sandboxes_nochangelogfound2(inputs)
	if (locale === "hi") return hi_sandboxes_nochangelogfound2(inputs)
	if (locale === "th") return th_sandboxes_nochangelogfound2(inputs)
	if (locale === "ja") return ja_sandboxes_nochangelogfound2(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_nochangelogfound2(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_nochangelogfound2(inputs)
	return ko_sandboxes_nochangelogfound2(inputs)
});
export { sandboxes_nochangelogfound2 as "sandboxes.noChangelogFound" }